// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 内容主推荐列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /tj-recommend/content-team/list */
export async function tjRecommendContentTeamListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendContentTeamResp>('/tj-recommend/content-team/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 课程推荐列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /tj-recommend/course-series/list */
export async function tjRecommendCourseSeriesListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendCourseSeriesResp>(
    '/tj-recommend/course-series/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 直播推荐列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /tj-recommend/live-room/list */
export async function tjRecommendLiveRoomListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendLiveRoomResp>('/tj-recommend/live-room/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 观点推荐列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /tj-recommend/stream-message/list */
export async function tjRecommendStreamMessageListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendStreamMessageResp>(
    '/tj-recommend/stream-message/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
